import { render, staticRenderFns } from "./Patologia.vue?vue&type=template&id=3ebda2d3&scoped=true&"
import script from "./Patologia.vue?vue&type=script&lang=js&"
export * from "./Patologia.vue?vue&type=script&lang=js&"
import style0 from "./Patologia.vue?vue&type=style&index=0&id=3ebda2d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebda2d3",
  null
  
)

export default component.exports